import { css } from 'styled-components';

const addButtonStyles = css`
  float: right;
  width: 120px;
  height: 45px;
  padding: 12px;
  position: relative;
  font-weight: bold;
  margin-bottom: 20px;
  font-family: franklin-gothic-urw, Helvetica, Arial, sans-serif;
`;

export default addButtonStyles;



// WEBPACK FOOTER //
// ./app/components/AddItemButton/addButtonStyles.js